export const unmockedGraphQlOperationsStore = new Set();

//# sourceMappingURL=store.js.map